import React from 'react'
import NumberField from './input/NumberField'

function StartMenu({handleStartClick, numberOfQuestions, setNumberOfQuestions}:{handleStartClick:() => void, numberOfQuestions:number, setNumberOfQuestions:(value: React.SetStateAction<number>) => void}) {
  return (
    <div>
      <NumberField
        value={numberOfQuestions}
        label={"Questions"}
        onChange={(e:React.ChangeEvent<HTMLInputElement>) =>
          setNumberOfQuestions(
            parseInt(e.target.value, 10) < 0
              ? 1
              : parseInt(e.target.value) > 10000
              ? 10000
              : parseInt(e.target.value.replace(/[|\-\\&;$%@"<>()+,]/g, ""), 10)
          )
        }
      />
      <button onClick={() => handleStartClick()}>Start</button>
      
    </div>
  )
}

export default StartMenu
